import { setRoute } from '../../routes/actions/set';
import { request as getReferredBetslip } from '../../betslip/actions/get-referred-betslip';
import { request as getCounters } from './get-counters';

export function request(id, name, params) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        dispatch({
            type: 'CUSTOMERS_OPEN_REQUEST',
            id,
            name
        });

        dispatch(getCounters(id));

        if (getState().routes.getIn([ 'customers', 'value' ]) != id) {
            dispatch(setRoute('customers:' + id + '', params ? params : {}));
        }
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_OPEN_ERROR',
        id,
        errors
    };
}

export function finish(customer) {
    let id = parseInt(customer.id, 10);

    return (dispatch) => {
        dispatch({
            type: 'CUSTOMERS_OPEN_FINISH',
            id,
            customer
        });
        dispatch(getReferredBetslip(id));
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_OPEN_CLEAR'
    };
}
